import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import EventAssignModal from './components/EventAssignModal';
import { hasEventsTag } from './utils/eventsTag';
export default function addEventDetails() {
  // Discussion.event() -> {startDate, endDate, location, url, posterUrl,
  // posterType} or null, already resolved server-side (see the `event`
  // field on DiscussionResource in extend.php).
  Object.defineProperty(Discussion.prototype, 'event', {
    value: Model.attribute('event')
  });

  // Discussion.canEditEvent() -> bool, true only for the discussion's
  // author or a moderator/admin (mirrors the same check in the event
  // field's set() on the server) - gates the inline edit link below as
  // well as the "Événement" button in DiscussionControls (addEventControl.js).
  Object.defineProperty(Discussion.prototype, 'canEditEvent', {
    value: Model.attribute('canEditEvent')
  });

  // In the discussion page's hero, next to the title - shows the event's
  // dates/place/url/poster when the discussion has one, plus an inline
  // "Ajouter un événement"/"Modifier" link for anyone allowed to change it
  // (mirrors champis-species' addSpeciesLabels.js: the DiscussionControls
  // button alone is easy to miss buried in the "..." menu, an inline link
  // right here is the more discoverable path). Same slot (-1, below
  // flarum-tags' own 'tags' item) as champis-species uses for its own
  // 'species' item - the two never actually collide since a discussion is
  // tagged either for species identification or for events, not both.
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    const event = discussion.event && discussion.event();
    const canEdit = discussion.canEditEvent && discussion.canEditEvent();
    const relevant = hasEventsTag(discussion.tags ? discussion.tags() : []);
    if (!event && !(canEdit && relevant)) return;
    const t = key => app.translator.trans(`champis-events.forum.event.${key}`);
    const openModal = () => app.modal.show(EventAssignModal, {
      discussion,
      onsubmit: newEvent => discussion.save({
        event: newEvent
      })
    });
    items.add('event', m("ul", {
      className: "DiscussionHero-event"
    }, event && event.startDate && m("li", null, m("i", {
      className: "icon fas fa-calendar-alt",
      "aria-hidden": "true"
    }), " ", formatDateRange(event.startDate, event.endDate)), event && event.location && m("li", null, m("i", {
      className: "icon fas fa-map-marker-alt",
      "aria-hidden": "true"
    }), " ", event.location), event && event.url && m("li", null, m("i", {
      className: "icon fas fa-link",
      "aria-hidden": "true"
    }), ' ', m("a", {
      href: event.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, event.url)), event && event.posterUrl && m("li", null, event.posterType === 'application/pdf' ? m("a", {
      href: event.posterUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("i", {
      className: "icon fas fa-file-pdf",
      "aria-hidden": "true"
    }), " ", t('poster_view_pdf')) : m("a", {
      href: event.posterUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "DiscussionHero-eventPoster"
    }, m("img", {
      src: event.posterUrl,
      alt: ""
    }))), canEdit && relevant && m("li", null, m("a", {
      className: "DiscussionHero-eventEdit",
      onclick: openModal
    }, m("i", {
      className: "icon fas fa-calendar-alt",
      "aria-hidden": "true"
    }), " ", t(event ? 'edit_link' : 'add_link')))), -1);
  });
}
function formatDateRange(start, end) {
  const fmt = d => {
    const [y, m, day] = d.split('-');
    return `${day}.${m}.${y}`;
  };
  if (end && end !== start) {
    return fmt(start) + ' - ' + fmt(end);
  }
  return fmt(start);
}